<template>
  <div class="field-info">
    <div class="flex items-center mb-6">
      <h2 style="color: #636363; border-right: solid 1px #dae1e7" class="py-1 pr-4">{{ breadcrumb[2].title }}</h2>
      <div class="pl-4">
        <vx-breadcrumb :route="$route" :breadcrumb="breadcrumb" />
      </div>
    </div>
    <vs-tabs :value="1">
      <vs-tab :label="type === 'type-d' ? '시설물 등록' : '사업장 등록'" @click.prevent="onClickTab(0)" />
      <vs-tab :label="type === 'type-d' ? '시설물 현황' : '사업장 현황'">
        <div>
          <!-- 부서 선택 -->
          <vx-card class="mb-8">
            <vs-row class="flex w-auto mr-4" vs-align="center">
              <vs-col class="w-auto mr-4">부서(수급업체)</vs-col>
              <vs-col class="w-auto">
                <vs-select autocomplete v-model="selectedCompanyId">
                  <vs-select-item v-for="(item, index) in companyList" :key="index" :text="item.com_name" :value="item.id" />
                </vs-select>
              </vs-col>
            </vs-row>
          </vx-card>

          <!-- 상세 내용 -->
          <vx-card>
            <field-info-type-a v-if="type === 'type-a'" :companyId="selectedCompanyId" />
            <field-info-type-b v-if="type === 'type-b'" :companyId="selectedCompanyId" />
            <field-info-type-c v-if="type === 'type-c'" :companyId="selectedCompanyId" />
            <field-info-type-d v-if="type === 'type-d'" :companyId="selectedCompanyId" />
            <field-info-type-material v-if="type === 'workplace-material'" :companyId="selectedCompanyId" />
          </vx-card>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import FieldInfoTypeA from "@/views/_BS/field-info/FieldInfoTypeA";
import FieldInfoTypeB from "@/views/_BS/field-info/FieldInfoTypeB";
import FieldInfoTypeC from "@/views/_BS/field-info/FieldInfoTypeC";
import FieldInfoTypeD from "@/views/_BS/field-info/FieldInfoTypeD";
import FieldInfoTypeMaterial from "@/views/_BS/field-info/FieldInfoTypeMaterial.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "CompanyFieldInfo",
  components: {
    FieldInfoTypeMaterial,
    FieldInfoTypeD,
    FieldInfoTypeC,
    FieldInfoTypeB,
    FieldInfoTypeA,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    type() {
      return this.$route.params.type;
    },
    breadcrumb() {
      switch (this.type) {
        case "type-a":
          return [{ title: "Home" }, { title: "사업장/시설물 현황" }, { title: "직영사업장", note: "중처법 제4조 시행령제4조 제5조", active: true }];
        case "type-b":
          return [{ title: "Home" }, { title: "사업장/시설물 현황" }, { title: "도급·용역·위탁 사업장", active: true }];
        case "type-c":
          return [{ title: "Home" }, { title: "사업장/시설물 현황" }, { title: "발주 사업장", active: true }];
        case "type-d":
          return [{ title: "Home" }, { title: "사업장/시설물 현황" }, { title: "시설물", active: true }];
        case "workplace-material":
          return [{ title: "Home" }, { title: "사업장/시설물 현황" }, { title: "원료·제조물 사업장", active: true }];
      }
    },
    loadBreadCrumbNote() {
      const lastItem = this.breadcrumb[this.breadcrumb.length - 1];
      if (lastItem && lastItem.note) {
        return lastItem.note;
      }
      return null;
    },
  },
  data() {
    return {
      selectedCompanyId: 0,
      companyList: [],
    };
  },
  mounted() {
    this.loadCompanyList();
    const routerHeader = document.getElementsByClassName("router-header");
    if (0 < routerHeader.length) {
      routerHeader[0].remove();
    }
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업장/시설물 개요" }, { title: "사업장(직접수행)  관리", active: true }]);
    },

    loadCompanyList() {
      HttpRequest.get("/api/v1/company/tree", { params: { projectId: this.projectId } }).then((value) => {
        const companyTree = value;
        const list = [];
        for (const com of companyTree) {
          list.push(com.descendant);
        }
        this.companyList = list;

        const myInfo = this.$store.state.auth.userInfo;
        this.selectedCompanyId = myInfo.company_id;
      });
    },

    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-workplace-list", query: { type: this.type } });
      } else if (tabIndex === 1) {
        // const proj_id = this.$route.params.proj_id
        // const type = 'type-a'
        // this.$router.push({ name: 'field-info-type', params: {proj_id, type}})
      }
    },
  },
};
</script>

<style scoped></style>
